import { Title as NewTopiaTitle } from './Title/Title';
import { ForBigDesktops } from './layout/BigDesktop';
import { ForSmallDesktops } from './layout/SmallDesktops';
import { Tablet } from './layout/Tablet';
import { LargeMobile } from './layout/LargeMobile';
import './newtopia.scss';
import { Mobile } from './layout/Mobile';

export const NewTopia = () => {
	return (
		<>
			<NewTopiaTitle />
			<ForBigDesktops />
			<ForSmallDesktops />
			<Tablet />
			<LargeMobile />
			<Mobile />
		</>
	);
};
